import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const logo = require("../assets/logbook-logo.svg");

const Logo = styled.img.attrs({
  src: logo,
  alt: "Archadeck Logbook logo"
})`
  display: block;
  margin-bottom: 16px;
  height: 28px;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
`;

const LoginBox = styled.div`
  flex: 1;
  max-width: 360px;
`;

const LoginWrapper = ({ children, ...otherProps }) => (
  <Container>
    <LoginBox {...otherProps}>
      <Link to="/login" tabIndex={-1}>
        <Logo />
      </Link>
      {children}
    </LoginBox>
  </Container>
);

export default LoginWrapper;



// WEBPACK FOOTER //
// ./src/components/LoginWrapper.js